import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import user from './modules/user.js'
import app from './modules/app.js'
import mfe from './modules/mfe.js'
import notice from './modules/notice.js'
import assessSimulate from './modules/assessSimulate.js'
import downLoadList from './modules/downLoadList.js'
export default createStore({
  state: {
    selectedKeys: ['0']
  },
  mutations: {},
  actions: {},
  modules: {
    app,
    mfe,
    user,
    notice,
    assessSimulate,
    downLoadList
  },
  // vuex持久化的插件，默认存储到local
  plugins: [
    createPersistedState({
      // 指定将数据存储到session
      storage: window.localStorage,
      reducer(val) {
        return {
          // 指定需要持久化的数据
          selectedKeys: val.selectedKeys,
          user: {
            // 权限菜单
            menus: val.user.menus,
            userInfo: val.user.userInfo,
            menuList: val.user.menuList
          },
          app: {
            otherSystemId: val.app.otherSystemId
          }
        }
      }
    })
  ]
})
